import React, { useContext, useEffect, useState } from 'react';
import { defaultPlace, Place } from '../../../app/models/Place';
import usePlaceService from '../../../app/services/hooks/usePlaceService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import PlaceFormContainer from './PlaceFormContainer';
import useSweetAlert from '../../../hooks/useSweetAlert';
import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import { Country } from '../../../app/models/Country';


interface Props {
    placeId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PlaceEdit = ({ placeId, onSaved, onCancel, onError }: Props) => {
    const { fetchingEditPlace, editPlace, fetchingUpdatePlace, updatePlace } = usePlaceService();

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [place, setPlace] = useState<Place>(defaultPlace);
    const [countries, setCountries] = useState<Country[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        editPlace(placeId, {
            onSuccess: (response: ServiceResponse) => {
                setPlace(response.data.place);
                setCountries(response.data.countries ?? []);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        useSweetAlert().spinnerAlert('Actualizando ubicación...', 400);
        updatePlace(placeId, place, {
            onSuccess: () => {
                useSweetAlert().closeSpinnerAlert();
                if (onSaved) onSaved();
            },
            onError: () => {
                useSweetAlert().closeSpinnerAlert();
                if (onError) onError();
            },
            onFieldError: (errorFields: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditPlace ? (
        <LazyLoading height="300" />
    ) : (
        <PlaceFormContainer
            fetching={fetchingUpdatePlace}
            action={update}
            cancel={cancel}
            place={place}
            setPlace={setPlace}
            countries={countries}
            errorFields={errorFields}
        />
    );
};

export default PlaceEdit;
